<div class="modal-header">
  <h3 class="modal-title">{{ 'Basket will be reset' | translate }}</h3>
</div>
<div class="modal-body">
  <p>{{ 'The order date was changed but you have articles in the basket, the basket will be reset.' | translate }}</p>
  <p></p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-dialog" (click)="okClick()">{{ 'Ok' | translate }}</button>
  <button class="btn btn-secondary btn-dialog" (click)="cancelClick()">{{ 'Cancel' | translate }}</button>
</div>
